export default __webpack_public_path__ + "static/media/blog-img11.c20dd466.png";